<template>
    <div>
        <search-bar @onSearch="onSearch"/>
        <question-card :question-list="questionList" wrapper-class="question-list"/>
        <Pagination :p-size.sync="pageSize"
                    :page-no.sync="pageIndex"
                    :page-sizes="[12, 24, 36, 48]"
                    :total="total"
                    @change="getList"/>
    </div>
</template>

<script>

import searchBar from "./searchBar";
import { getQuestionnaireList } from "@/api/new-question-iteration/question-user"
import questionCard from "@/components/questionCard";
import Pagination from "@/components/Pagination"
export default {
    name: "CurrentQuestion",
    data () {
        return {
            pageIndex: 1,
            pageSize: 12,
            total: 0,
            questionList: []
        }
    },
    components: {
        searchBar,
        questionCard,
        Pagination
    },
    created() {
        this.getList()
    },
    methods: {
        onSearch (form) {
            this.searchForm = form
            this.pageIndex = 1
            this.getList()
        },
        getList () {
            const { pageIndex, pageSize, searchForm = {} } = this
            getQuestionnaireList({
                pageIndex,
                pageSize,
                Type: 0,
                ...searchForm
            }).then(res => {
                this.questionList = res.data
                this.total = res.count
            })
        }
    }
}
</script>

<style scoped lang="less">
::v-deep .question-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: auto;
    // 间隙
    grid-gap: 30px;
}

</style>
